export const Bio = {
  name: "Omar Zaroaul",
  roles: [
    "Full Stack Developer",
    "Programmer",
    "tech lover",
  ],
  description:
    "As a Junior Full-Stack Developer, I am eager to grow my skills and knowledge by seizing opportunities for learning and advancement in the field.",
  github: "https://github.com/Omar-Zaroual",
  resume:
    "https://drive.google.com/file/d/1RzC9H7tId6ZRi1F-NUP4_VGhVaLSSuoL/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/omar-zaroual-2a8a34295?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
  twitter: "/",
  insta: "https://www.instagram.com/omar_zl_?igsh=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr",
  facebook: "/",
};

export const skills = [
  {
    title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Php",
          image: "image/icons8-php-48.png",
        },
        {
          name: "laravel",
          image: "image/icons8-laravel-64.png",
        },
        {
          name: "Java EE",
          image: "image/java.png",
        }
      ],
    },
    
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
          "image/git.png"
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "image/postman-icon.webp",
        },
        {
          name: "Agile Scrum",
          image:
            "image/scrum.png",
        },
        {
          name: "UML",
          image:
            "image/icons8-tâches-parallèles-64.png",
        },
        {
          name: "Merise",
          image:
            "image/icon-merise.png",
        },
      ],
    },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.hcp.ma/photo/art/default/60458265-44248374.jpg?v=1637595904",
    role: " SEASONAL JOB  -  Census Agent",
    company: "HIGH COMMISSION FOR PLANNING - MOROCCO ",
    date: "August 2024 - September 2024",
    desc: "General Census of Population and Housing (RGPH) of Morocco 2024",
    skills: [
      "Census Methodology Training",
      "Data Collection and Interviewing",
      "Confidentiality Management",
      "Stress Management and Adaptability",
    ],
    doc: "",
  },
  {
    id: 0,
    img: "image/ensamRabat.JPG",
    role: "STAGE  -  Full-Stack Devloper PHP",
    company: "NATIONAL HIGHER SCHOOL OF ARTS AND CRAFTS OF RABAT (ENSAM) ",
    date: "June 2024 - July 2024",
    desc: "Developing a platform to streamline the planning and scheduling of training sessions for institutions.",
    skills: [
      "Gantt",
      "UML",
      "GitHub",
      "MySQL",
      "HTML",
      "CSS",
      "Bootstrap",
      "React.JS",
      "Laravel",
      "API Rest",
      "JWT",
    ],
    doc: "",
  },
  {
    id: 0,
    img: "image/Ministere-de-la-Justice-Concours-Emploi-Recrutement.webp",
    role: "STAGE  -  Full-Stack Devloper",
    company: "MOROCCAN MINISTRY OF JUSTICE ",
    date: "March 2023 - April 2023",
    desc: "Developing a comprehensive web application for efficient stock management and inventory control.",
    skills: [
      "Agile Scrum",
      "UML",
      "MySQL",
      "HTML",
      "CSS",
      "Bootstrap",
      "Laravel",
    ],
    doc: "image/stage.JPG",
  },

];

export const education = [
  {
    id: 0,
    img: "image/ensam.png",
    school: "École Nationale supérieure d'Arts et Métiers de Rabat (ENSAM)",
    date: "March 2024 - Jullie 2024",
    desc: "I have successfully completed the JobInTech Full Stack PHP training program at the École Nationale Supérieure d'Arts et Métiers de Rabat (ENSAM).",
    degree: "Certification JobIntech FULL-STACK PHP",
    doc: "image/AttestationJobintech.jpg"
  },
  {
    id: 0,
    img: "image/est.png",
    school: "École Supérieure de Technologie Kénitra (EST)",
    date: "2023 - 2024",
    desc: "I graduated with a License degree from École Supérieure de Technologie Kénitra (EST).",
    degree: "LUS Génie informatique",
    doc: "image/DiplomeLicence.jpg"
  },
  {
    id: 1,
    img: "image/ofppt.jpg",
    school: "Institut Spécialisé de Technologie Appliquée HAYRIAD RABAT",
    date: "2021 - 2023",
    desc: "I completed my Diplôme Technicien spécialisé en Développement Digital WEB Option FULL-STACK at Institut Spécialisé de Technologie Appliquée HAY RIAD RABAT, where I studied Computer Science.",
    degree: "Diplôme Technicien spécialisé en Développement Digital WEB Option FULL-STACK",
    doc: "image/diplome.JPG",
  },
  {
    id: 2,
    img: "image/lycées.png",
    school: "Lycée Abi Dar El Ghifari RABAT",
    date: "2019 - 2020",
    desc: "I completed my Scientific Baccalaureate Option Physical Sciences at Lycée Abi Dar El Ghifari RABAT",
    degree: "Scientific Baccalaureate Option Physical Sciences",
    doc: "image/bac.JPG",
  },
];

export const projects = [
  {
    id: 13,
    title: "EduHub: Training Session Planning & Scheduling for Institutions",
    description: `I developed an online platform designed to simplify and improve the management of training programs for organizations. With a user-friendly and intuitive interface, the platform enables organizers to easily plan and coordinate various types of training, including in-person seminars, online courses, and hybrid workshops. Key features include the creation of customizable training sessions, the assignment of qualified trainers, participant registration management, and comprehensive progress tracking.

    For participants, the platform offers a seamless and immersive experience. They can easily enroll in training programs, access interactive multimedia content, engage in discussions with peers and trainers through integrated forums, and track their progress with personalized dashboards. The platform supports various learning formats such as self-paced modules, live sessions, and online assessments, ensuring a dynamic and engaging learning process.

    This versatile solution caters to the training needs of SMEs, academic institutions, and large enterprises. It aims to streamline the training management process while enhancing the effectiveness and overall impact of the programs.`,
    image: "image/EduHubPlateform.png",
    tags: [
      "Gantt",
      "UML",
      "GitHub",
      "MySQL",
      "HTML",
      "CSS",
      "Bootstrap",
      "React.JS",
      "Laravel",
      "API Rest",
      "JWT",
    ],
    category: "website",
  },
  {
    id: 13,
    title: "Luxury Watch Platform",
    description: "The platform offers luxury watches that combine elegance with advanced technology for a sophisticated experience. Check out the Smart Digital Watch collection, designed to elevate a luxurious lifestyle. Each timepiece blends sophistication and innovation, perfect for the discerning connoisseur.",
    image: "image/LuxuryWatchPlatform.png",
    tags: [
      "Agile",
      "UML",
      "MySQL",
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
      "Laravel",
    ],
    category: "web site ecommerce",
  },
  {
    id: 12,
    title: "Literacy Training Management Platform",
    description: "The online platform is designed to simplify and improve the management of literacy training programs for organizations. With a user-friendly and intuitive interface, it allows organizers to easily plan and coordinate various types of training, whether it's in-person seminars, online courses, or hybrid workshops. Key features include the creation of customized training sessions, the assignment of qualified trainers, participant registration management, and training progress tracking.\n\nFor participants, the platform offers an immersive and seamless experience. They can easily register for training, access interactive and multimedia content, engage with other participants and trainers through integrated discussion forums, and track their progress with personalized dashboards. Additionally, the platform supports various training formats such as self-paced learning modules, live sessions, and online assessments to ensure a dynamic and engaging learning experience.",
    image: "image/TrainingManagementPlatform.png",
    tags: [
      "UML",
      "GitHub",
      "MySQL",
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
      "Laravel",
      "React.Js",
    ],
    category: "web site",
  },
  {
    id: 11,
    title: "PGC-GYM",
      description: "The gym website offers a comprehensive online store, providing customers the opportunity to purchase a variety of products to complement their workouts. Our shop includes a wide range of high-quality proteins, vitamins, and nutritional supplements essential for maximizing performance and supporting muscle recovery. Furthermore, we offer a selection of sports accessories such as yoga mats, dumbbells, resistance bands, fitness balls, and more, to assist our customers in achieving their fitness goals. Additionally, our site allows visitors to directly register for our gym, providing all necessary information and offering a quick and convenient signup experience. Whether for shopping, finding necessary supplements, or becoming a member of our gym, our website provides user-friendly and comprehensive features to cater to our customers needs, offering a convenient and satisfying online experience.",
    image:
      "image/PCG-GYM.png",
    tags: [
      "Gantt",
      "UML",
      "Merise",
      "MySQL",
      "HTML",
      "CSS",
      "Bootstrap",
      "Laravel",
    ],
    category: "web site",
  },
  {
    id: 10,
    title: "stock management",
    
    description:
      "This website enables the staff to check stock and product statistics, view entry and exit histories, as well as input new data to adjust quantities. Additionally, it provides the option to download PDF files containing product details and their movements, offering flexibility in accessing data, whether online or offline. In summary, this platform streamlines stock management by furnishing tools for informed decision-making and facilitating convenient access to pertinent information for the staff.",
    image:
      "image/stock-management.jpg",
    tags: [
      "Gantt",
      "Agile Scrum",
      "UML",
      "Merise",
      "MySQL",
      "HTML",
      "CSS",
      "Bootstrap",
      "Laravel",
    ],
    category: "web app",
  },
  {
    id: 9,
    title: "Country Capitals Quiz Game",
    description: "The Country Capitals Quiz Game is an interactive web application designed to test and enhance your knowledge of world capitals. Players are presented with the name of a country and must select the correct capital city from multiple choices. The game keeps track of the player's score, providing instant feedback on correct and incorrect answers. At the end of the quiz, the final score is displayed, allowing players to see how well they performed. This educational and entertaining game is a fun way to learn about geography and improve memory.",
    image: "image/CountryCapitalsQuizGame.png",
    tags: [
      "HTML",
      "JavaScript",
      "CSS",
    ],
    category: "web application"
  },
  {
    id: 10,
    title: "Library Management Web Application",
    description: "Development of a web application for library management using Java EE, Bootstrap, and CSS, allowing users to browse available books, borrow them, and return them. The application provides a simple and intuitive interface to facilitate user navigation and interaction. Librarians have a dedicated interface that enables them to add, modify, and delete books from the database, as well as manage current loans while tracking the availability of books. The system ensures efficient user management, with features for monitoring loans and returns, guaranteeing smooth inventory management and easy access for both users and staff.",
    image: "image/Prj-Javaee.png",
    tags: [
      "UML",
      "Java EE",
      "HTML",
      "CSS",
      "Bootstrap",
    ],
    category: "web application"
  },
  {
    id: 11,
    title: "Memory Card Game Project",
    description: "The project involves developing a Memory Card game, where the user needs to match pairs of identical cards, without any animations. The game records the score and time for each session in local storage for personalized tracking. After each game, a menu allows the user to modify game settings, such as switching between 4, 12, or 16 cards, and changing the background. Additionally, the History section displays a list of previously played games, including scores and times for each session. The design of the game is fully customized, inspired by an example image to illustrate the game's concept, but featuring a unique interface for each project.",
    image: "image/MemoryCardGame.png",
    tags: [
      "React Js",
      "HTML",
      "Tailwind Css",
    ],
    category: "web application"
  }
  
  
];


